import React from "react";

import { FestivalDao, LocationDao, VenueDao } from "../../src/DAO";
import { Constants } from "../../src/config";
import slugify from "slugify";
import moment from "moment";
import GuideRooftop from "../../components_web/guides/GuideRooftop";
import GuideSpa from "../../components_web/guides/GuideSpa";
import GuideBeachful from "../../components_web/guides/GuideBeachful";
import GuideCocktayl from "../../components_web/guides/GuideCocktayl";
import GuideFestyful from "../../components_web/guides/GuideFestyful";
import GuideVybeful from "../../components_web/guides/GuideVybeful";
import GuidePrefab from "../../components_web/guides/GuidePrefab";
import GuideZoo from "../../components_web/guides/GuideZoo";
import GuideParkful from "../../components_web/guides/GuideParkful";
import GuideCasino from "../../components_web/guides/GuideCasino";
import GuideCastle from "../../components_web/guides/GuideCastle";
import GuideResort from "../../components_web/guides/GuideResort";
import GuideAparthotel from "../../components_web/guides/GuideAparthotel";
import { uniqBy } from "lodash";

export async function getServerSideProps(context) {
  try {
    const { params, query } = context;
    let listData = [];
    let countListData = 0;
    let continentDataSelected = null;
    let listDataCountry = [];
    let listDataState = [];
    let listDataCity = [];
    let listDataFilter = [];
    let paramsFinal = {};
    const categoryType =
      process.env.NEXT_PUBLIC_APP_NAME === "Vybeful"
        ? Constants.categoryType.CATEGORY_VENUE
        : process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub"
        ? Constants.categoryType.CATEGORY_ROOFTOP
        : process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl"
        ? Constants.categoryType.CATEGORY_VENUE_COCKTAIL
        : process.env.NEXT_PUBLIC_APP_NAME === "Beachful"
        ? Constants.categoryType.CATEGORY_VENUE_BEACHFUL
        : process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld"
        ? Constants.categoryType.CATEGORY_PREFAB_COMPANY
        : process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia"
        ? Constants.categoryType.CATEGORY_ZOO
        : process.env.NEXT_PUBLIC_APP_NAME === "Parkful"
        ? Constants.categoryType.CATEGORY_PARKFUL
        : process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino"
        ? Constants.categoryType.CATEGORY_CASINO
        : process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia"
        ? Constants.categoryType.CATEGORY_CASTLE
        : process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club"
        ? Constants.categoryType.CATEGORY_RESORT
        : process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub"
        ? Constants.categoryType.CATEGORY_APARTHOTEL
        : process.env.NEXT_PUBLIC_APP_NAME === "SpaClub"
        ? Constants.categoryType.CATEGORY_SPA
        : process.env.NEXT_PUBLIC_APP_NAME === "Festicket"
        ? Constants.categoryType.CATEGORY_FESTIVAL
        : Constants.categoryType.CATEGORY_VENUE;

    const listDataContinent = await new Promise((resolve, reject) => {
      LocationDao.findProgmatic({
        categoryType,
        progFilterType: "continent",
        year:
          process.env.NEXT_PUBLIC_APP_NAME === "Festicket"
            ? params.slugs[0]
            : null,
      })
        .then((result) => resolve(result || []))
        .catch((err) => reject(err));
    });

    if (process.env.NEXT_PUBLIC_APP_NAME === "Festicket") {
      if (params.slugs.length >= 1) {
        listData = listDataContinent;
      }
      if (params.slugs.length >= 2) {
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[1]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic(
            continentDataSelected?.isCustomRegion
              ? {
                  categoryType,
                  progFilterType: "country",
                  region: JSON.stringify(
                    continentDataSelected?.originalRegions || []
                  ),
                  // subregion: JSON.stringify(
                  //   continentDataSelected?.originalSubregions || []
                  // ),
                  year: params.slugs[0],
                }
              : {
                  categoryType,
                  progFilterType: "country",
                  region: JSON.stringify([continentDataSelected?.region]),
                  year: params.slugs[0],
                }
          )
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCountry;
      }
      if (params.slugs.length >= 3) {
        listDataCity = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "city",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
              )?.countryId || null,
            year: params.slugs[0],
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        // if United States country_id=233 have States List
        // if (
        //   listDataCountry?.find(
        //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
        //   )?.countryId == 233
        // ) {
        listDataState = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "state",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
              )?.countryId || null,
            year: params.slugs[0],
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });
        // }

        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[2]
              )?.countryId || null,
            cityId: params.slugs[3]?.includes("festival")
              ? null
              : listDataCity?.find(
                  (i) => slugify(i.cityName?.toLowerCase()) === params.slugs[3]
                )?.cityId || null,
            year: params.slugs[0],
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 1,
              sortType: Constants.sortByAction.SORT_BY_RECENT,
              startDateFrom: moment(params.slugs[0] + "-01-01")
                .startOf("year")
                .format("YYYY-MM-DD"),
              startDateTo: moment(params.slugs[0] + "-01-01")
                .endOf("year")
                .format("YYYY-MM-DD"),
              progFilterId: params.slugs[3]?.includes("-festivals")
                ? listDataFilter?.find(
                    (i) =>
                      slugify(i.filterName?.toLowerCase()) ===
                      params.slugs[3]?.replace(`-festivals`, "")
                  )?.filterId
                : null,
              cityId: params.slugs[3]?.includes("festival")
                ? null
                : listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) === params.slugs[3]
                  )?.cityId || null,
              stateId: params.slugs[3]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[3]?.replace("-state", "")
                  )?.stateId || null
                : null,
              countryId: params.slugs[3]?.includes("festival")
                ? [
                    listDataCountry?.find(
                      (i) =>
                        slugify(i.countryName?.toLowerCase()) ===
                        params.slugs[2]
                    )?.countryId || null,
                  ]
                : null,
            };
            FestivalDao.findWeb(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "Vybeful") {
      // Venue
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic(
            continentDataSelected?.isCustomRegion
              ? {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify(continentDataSelected?.originalRegions)
                    : null,
                  // subregion: continentDataSelected
                  //   ? JSON.stringify(continentDataSelected?.originalSubregions)
                  //   : null,
                }
              : {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify([continentDataSelected?.region])
                    : null,
                }
          )
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCountry;
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        listDataCity = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "city",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCity;
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
            cityId:
              listDataCity?.find(
                (i) => slugify(i.cityName?.toLowerCase()) === params.slugs[2]
              )?.cityId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              venueStatus: [
                Constants.venueStatus.FE_STAT_OPEN,
                Constants.venueStatus.FE_STAT_CLOSE,
                Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
              ],
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: params.slugs[3]?.includes("-clubs")
                ? listDataFilter?.find(
                    (i) =>
                      slugify(i.filterName?.toLowerCase()) ===
                      params.slugs[3]?.replace(`-clubs`, "")
                  )?.filterId
                : null,
              cityId:
                listDataCity?.find(
                  (i) => slugify(i.cityName?.toLowerCase()) === params.slugs[2]
                )?.cityId || null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic(
            continentDataSelected?.isCustomRegion
              ? {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify(continentDataSelected?.originalRegions)
                    : null,
                  // subregion: continentDataSelected
                  //   ? JSON.stringify(continentDataSelected?.originalSubregions)
                  //   : null,
                }
              : {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify([continentDataSelected?.region])
                    : null,
                }
          )
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCountry;
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        listDataCity = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "city",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCity;
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/jakarta
        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
            cityId:
              listDataCity?.find(
                (i) => slugify(i.cityName?.toLowerCase()) === params.slugs[2]
              )?.cityId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 4) {
        if (params.slugs[3] === "bar-rooftops") {
          return {
            redirect: {
              permanent: true,
              destination: `/guides/${params.slugs[0]}/${params.slugs[1]}/${params.slugs[2]}/rooftop-bars`,
            },
          };
        }
        if (params.slugs[3] === "pool-rooftops") {
          return {
            redirect: {
              permanent: true,
              destination: `/guides/${params.slugs[0]}/${params.slugs[1]}/${params.slugs[2]}/rooftop-pools`,
            },
          };
        }
        if (params.slugs[3] === "restaurant-rooftops") {
          return {
            redirect: {
              permanent: true,
              destination: `/guides/${params.slugs[0]}/${params.slugs[1]}/${params.slugs[2]}/rooftop-restaurants`,
            },
          };
        }

        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              venueStatus: [
                Constants.venueStatus.FE_STAT_OPEN,
                Constants.venueStatus.FE_STAT_CLOSE,
                Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
              ],
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId:
                params.slugs[3]?.includes("-rooftops") ||
                params.slugs[3]?.includes("rooftop-")
                  ? listDataFilter?.find(
                      (i) =>
                        slugify(i.filterName?.toLowerCase()) ===
                        params.slugs[3]
                          ?.replace("rooftop-", "")
                          ?.replace("bars", "bar")
                          ?.replace("restaurants", "restaurant")
                          ?.replace("pools", "pool")
                          ?.replace(`-rooftops`, "")
                    )?.filterId
                  : null,
              cityId:
                listDataCity?.find(
                  (i) => slugify(i.cityName?.toLowerCase()) === params.slugs[2]
                )?.cityId || null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic(
            continentDataSelected?.isCustomRegion
              ? {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify(continentDataSelected?.originalRegions)
                    : null,
                  // subregion: continentDataSelected
                  //   ? JSON.stringify(continentDataSelected?.originalSubregions)
                  //   : null,
                }
              : {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify([continentDataSelected?.region])
                    : null,
                }
          )
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCountry;
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        listDataCity = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "city",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCity;
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/jakarta
        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
            cityId:
              listDataCity?.find(
                (i) => slugify(i.cityName?.toLowerCase()) === params.slugs[2]
              )?.cityId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              venueStatus: [
                Constants.venueStatus.FE_STAT_OPEN,
                Constants.venueStatus.FE_STAT_CLOSE,
                Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
              ],
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: params.slugs[3]?.includes(`-cocktail-bars`)
                ? listDataFilter?.find(
                    (i) =>
                      slugify(i.filterName?.toLowerCase()) ===
                      params.slugs[3]?.replace(`-cocktail-bars`, "")
                  )?.filterId
                : null,
              cityId:
                listDataCity?.find(
                  (i) => slugify(i.cityName?.toLowerCase()) === params.slugs[2]
                )?.cityId || null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "Beachful") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic(
            continentDataSelected?.isCustomRegion
              ? {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify(continentDataSelected?.originalRegions)
                    : null,
                  // subregion: continentDataSelected
                  //   ? JSON.stringify(continentDataSelected?.originalSubregions)
                  //   : null,
                }
              : {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify([continentDataSelected?.region])
                    : null,
                }
          )
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCountry;
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        listDataState = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "state",
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listDataCity = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "city",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        if (params.slugs[2].includes("beach-clubs")) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                venueStatus: [
                  Constants.venueStatus.FE_STAT_OPEN,
                  Constants.venueStatus.FE_STAT_CLOSE,
                  Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
                ],
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: params.slugs[2]?.includes(`-beach-clubs`)
                  ? listDataFilter?.find(
                      (i) =>
                        slugify(i.filterName?.toLowerCase()) ===
                        params.slugs[2]?.replace(`-beach-clubs`, "")
                    )?.filterId
                  : null,
                countryId: listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[1]
                        )?.countryId
                      ),
                    ]
                  : null,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState
                    ?.filter((item) => item.stateName)
                    ?.find(
                      (i) =>
                        slugify(i.stateName?.toLowerCase()) ===
                        params.slugs[2]?.replace("-state", "")
                    )?.stateId || null
                : null,
              cityId: !params.slugs[2]?.includes("-state")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) === params.slugs[2]
                  )?.cityId || null
                : null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              venueStatus: [
                Constants.venueStatus.FE_STAT_OPEN,
                Constants.venueStatus.FE_STAT_CLOSE,
                Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
              ],
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: params.slugs[3]?.includes(`-beach-clubs`)
                ? listDataFilter?.find(
                    (i) =>
                      slugify(i.filterName?.toLowerCase()) ===
                      params.slugs[3]?.replace(`-beach-clubs`, "")
                  )?.filterId
                : null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState
                    ?.filter((item) => item.stateName)
                    ?.find(
                      (i) =>
                        slugify(i.stateName?.toLowerCase()) ===
                        params.slugs[2]?.replace("-state", "")
                    )?.stateId || null
                : null,
              cityId: !params.slugs[2]?.includes("-state")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) === params.slugs[2]
                  )?.cityId || null
                : null,
              countryId: listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )
                ? [
                    JSON.stringify(
                      listDataCountry?.find(
                        (i) =>
                          slugify(i.countryName?.toLowerCase()) ===
                          params.slugs[1]
                      )?.countryId
                    ),
                  ]
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "SpaClub") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic(
            continentDataSelected?.isCustomRegion
              ? {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify(continentDataSelected?.originalRegions)
                    : null,
                  // subregion: continentDataSelected
                  //   ? JSON.stringify(continentDataSelected?.originalSubregions)
                  //   : null,
                }
              : {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify([continentDataSelected?.region])
                    : null,
                }
          )
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCountry;
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        listDataState = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "state",
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listDataCity = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "city",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        if (params.slugs[2].includes("spas")) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                venueStatus: [
                  Constants.venueStatus.FE_STAT_OPEN,
                  Constants.venueStatus.FE_STAT_CLOSE,
                  Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
                ],
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: params.slugs[2]?.includes(`-spas`)
                  ? listDataFilter?.find(
                      (i) =>
                        slugify(i.filterName?.toLowerCase()) ===
                        params.slugs[2]
                          ?.replace("day", "day-spa")
                          ?.replace("destination", "destination-spa")
                          ?.replace("thermal", "thermal-spa")
                          ?.replace("hotel", "hotel-spa")
                          ?.replace("club", "club-spa")
                          ?.replace("medical", "medical-spa")
                          ?.replace(`-spas`, "")
                    )?.filterId
                  : null,
                countryId: listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[1]
                        )?.countryId
                      ),
                    ]
                  : null,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: !params.slugs[2]?.includes("-state")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) === params.slugs[2]
                  )?.cityId || null
                : null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              venueStatus: [
                Constants.venueStatus.FE_STAT_OPEN,
                Constants.venueStatus.FE_STAT_CLOSE,
                Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
              ],
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: params.slugs[3]?.includes(`-spas`)
                ? listDataFilter?.find(
                    (i) =>
                      slugify(i.filterName?.toLowerCase()) ===
                      params.slugs[3]
                        ?.replace("day", "day-spa")
                        ?.replace("destination", "destination-spa")
                        ?.replace("thermal", "thermal-spa")
                        ?.replace("hotel", "hotel-spa")
                        ?.replace("club", "club-spa")
                        ?.replace("medical", "medical-spa")
                        ?.replace(`-spas`, "")
                  )?.filterId
                : null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: !params.slugs[2]?.includes("-state")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) === params.slugs[2]
                  )?.cityId || null
                : null,
              countryId: listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )
                ? [
                    JSON.stringify(
                      listDataCountry?.find(
                        (i) =>
                          slugify(i.countryName?.toLowerCase()) ===
                          params.slugs[1]
                      )?.countryId
                    ),
                  ]
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "country",
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        if (params.slugs[0] !== "world") {
          listDataState = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "state",
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[0]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });
        }

        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[0]
              )?.countryId || null,
            isWorld: params.slugs[0] === "world",
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: params.slugs[1]?.includes(
                `-prefab-homes-manufacturers`
              )
                ? listDataFilter?.find(
                    (i) =>
                      slugify(i.filterName?.toLowerCase()) ===
                      params.slugs[1]?.replace(
                        `-prefab-homes-manufacturers`,
                        ""
                      )
                  )?.filterId
                : null,
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[0]
                ) && params.slugs[0] !== "world"
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[0]
                        )?.countryId
                      ),
                    ]
                  : null,
              stateId: params.slugs[1]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[1]?.replace("-state", "")
                  )?.stateId || null
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        if (params.slugs[0] === "world") {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              isWorld: true,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        } else {
          listDataCountry = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic(
              continentDataSelected?.isCustomRegion
                ? {
                    categoryType,
                    progFilterType: "country",
                    region: continentDataSelected
                      ? JSON.stringify(continentDataSelected?.originalRegions)
                      : null,
                    // subregion: continentDataSelected
                    //   ? JSON.stringify(
                    //       continentDataSelected?.originalSubregions
                    //     )
                    //   : null,
                  }
                : {
                    categoryType,
                    progFilterType: "country",
                    region: continentDataSelected
                      ? JSON.stringify([continentDataSelected?.region])
                      : null,
                  }
            )
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataCountry;
        }
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        if (
          !params.slugs[1].includes("-city") &&
          !params.slugs[1].includes("-state") &&
          params.slugs[0] === "world"
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) ===
                    params.slugs[1]
                      ?.replace("zoos", "zoo")
                      ?.replace("wildlife-parks", "wildlife-park")
                      ?.replace("animal-sanctuaries", "animal-sanctuary")
                      ?.replace("aquariums", "aquarium")
                      ?.replace("marine-mammal-parks", "marine-mammal-park")
                      ?.replace("penguinariums", "penguinarium")
                      ?.replace("dolphinariums", "dolphinarium")
                      ?.replace("aviaries", "aviary")
                      ?.replace("nocturnal-houses", "nocturnal-house")
                      ?.replace("petting-zoos", "petting-zoo")
                      ?.replace("animal-theme-parks", "animal-theme-park")
                      ?.replace("reptilariums", "reptilarium")
                      ?.replace("herpetariums", "herpetarium")
                      ?.replace("serpentariums", "serpentarium")
                      ?.replace("farms", "farm")
                      ?.replace("oceanariums", "oceanarium")
                )?.filterId,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataState = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "state",
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listDataCity = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "city",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        if (
          !params.slugs[2].includes("-city") &&
          !params.slugs[2].includes("-state")
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) ===
                    params.slugs[2]
                      ?.replace("zoos", "zoo")
                      ?.replace("wildlife-parks", "wildlife-park")
                      ?.replace("animal-sanctuaries", "animal-sanctuary")
                      ?.replace("aquariums", "aquarium")
                      ?.replace("marine-mammal-parks", "marine-mammal-park")
                      ?.replace("penguinariums", "penguinarium")
                      ?.replace("dolphinariums", "dolphinarium")
                      ?.replace("aviaries", "aviary")
                      ?.replace("nocturnal-houses", "nocturnal-house")
                      ?.replace("petting-zoos", "petting-zoo")
                      ?.replace("animal-theme-parks", "animal-theme-park")
                      ?.replace("reptilariums", "reptilarium")
                      ?.replace("herpetariums", "herpetarium")
                      ?.replace("serpentariums", "serpentarium")
                      ?.replace("farms", "farm")
                      ?.replace("oceanariums", "oceanarium")
                )?.filterId,
                countryId: listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[1]
                        )?.countryId
                      ),
                    ]
                  : null,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: listDataFilter?.find(
                (i) =>
                  slugify(i.filterName?.toLowerCase()) ===
                  params.slugs[3]
                    ?.replace("zoos", "zoo")
                    ?.replace("wildlife-parks", "wildlife-park")
                    ?.replace("animal-sanctuaries", "animal-sanctuary")
                    ?.replace("aquariums", "aquarium")
                    ?.replace("marine-mammal-parks", "marine-mammal-park")
                    ?.replace("penguinariums", "penguinarium")
                    ?.replace("dolphinariums", "dolphinarium")
                    ?.replace("aviaries", "aviary")
                    ?.replace("nocturnal-houses", "nocturnal-house")
                    ?.replace("petting-zoos", "petting-zoo")
                    ?.replace("animal-theme-parks", "animal-theme-park")
                    ?.replace("reptilariums", "reptilarium")
                    ?.replace("herpetariums", "herpetarium")
                    ?.replace("serpentariums", "serpentarium")
                    ?.replace("farms", "farm")
                    ?.replace("oceanariums", "oceanarium")
              )?.filterId,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
              countryId: listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )
                ? [
                    JSON.stringify(
                      listDataCountry?.find(
                        (i) =>
                          slugify(i.countryName?.toLowerCase()) ===
                          params.slugs[1]
                      )?.countryId
                    ),
                  ]
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "Parkful") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        if (params.slugs[0] === "world") {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              isWorld: true,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        } else {
          listDataCountry = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic(
              continentDataSelected?.isCustomRegion
                ? {
                    categoryType,
                    progFilterType: "country",
                    region: continentDataSelected
                      ? JSON.stringify(continentDataSelected?.originalRegions)
                      : null,
                    // subregion: continentDataSelected
                    //   ? JSON.stringify(
                    //       continentDataSelected?.originalSubregions
                    //     )
                    //   : null,
                  }
                : {
                    categoryType,
                    progFilterType: "country",
                    region: continentDataSelected
                      ? JSON.stringify([continentDataSelected?.region])
                      : null,
                  }
            )
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataCountry;
        }
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        if (
          !params.slugs[1].includes("-city") &&
          !params.slugs[1].includes("-state") &&
          params.slugs[0] === "world"
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) ===
                    params.slugs[1]
                      ?.replace("theme-parks", "theme-park")
                      ?.replace("waterparks", "waterpark")
                )?.filterId,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataState = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "state",
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listDataCity = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "city",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        if (
          !params.slugs[2].includes("-city") &&
          !params.slugs[2].includes("-state")
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) ===
                    params.slugs[2]
                      ?.replace("theme-parks", "theme-park")
                      ?.replace("waterparks", "waterpark")
                )?.filterId,
                countryId: listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[1]
                        )?.countryId
                      ),
                    ]
                  : null,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: listDataFilter?.find(
                (i) =>
                  slugify(i.filterName?.toLowerCase()) ===
                  params.slugs[3]
                    ?.replace("theme-parks", "theme-park")
                    ?.replace("waterparks", "waterpark")
              )?.filterId,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
              countryId: listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )
                ? [
                    JSON.stringify(
                      listDataCountry?.find(
                        (i) =>
                          slugify(i.countryName?.toLowerCase()) ===
                          params.slugs[1]
                      )?.countryId
                    ),
                  ]
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        if (params.slugs[0] === "world") {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              isWorld: true,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        } else {
          listDataCountry = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic(
              continentDataSelected?.isCustomRegion
                ? {
                    categoryType,
                    progFilterType: "country",
                    region: continentDataSelected
                      ? JSON.stringify(continentDataSelected?.originalRegions)
                      : null,
                    // subregion: continentDataSelected
                    //   ? JSON.stringify(
                    //       continentDataSelected?.originalSubregions
                    //     )
                    //   : null,
                  }
                : {
                    categoryType,
                    progFilterType: "country",
                    region: continentDataSelected
                      ? JSON.stringify([continentDataSelected?.region])
                      : null,
                  }
            )
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataCountry;
        }
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        if (
          !params.slugs[1].includes("-city") &&
          !params.slugs[1].includes("-state") &&
          params.slugs[0] === "world"
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) === params.slugs[1]
                )?.filterId,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataState = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "state",
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listDataCity = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "city",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        if (
          !params.slugs[2].includes("-city") &&
          !params.slugs[2].includes("-state")
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) === params.slugs[2]
                )?.filterId,
                countryId: listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[1]
                        )?.countryId
                      ),
                    ]
                  : null,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: listDataFilter?.find(
                (i) => slugify(i.filterName?.toLowerCase()) === params.slugs[3]
              )?.filterId,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
              countryId: listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )
                ? [
                    JSON.stringify(
                      listDataCountry?.find(
                        (i) =>
                          slugify(i.countryName?.toLowerCase()) ===
                          params.slugs[1]
                      )?.countryId
                    ),
                  ]
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic(
            continentDataSelected?.isCustomRegion
              ? {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify(continentDataSelected?.originalRegions)
                    : null,
                  // subregion: continentDataSelected
                  //   ? JSON.stringify(continentDataSelected?.originalSubregions)
                  //   : null,
                }
              : {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify([continentDataSelected?.region])
                    : null,
                }
          )
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCountry;
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        listDataState = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "state",
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listDataCity = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "city",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        if (
          !params.slugs[2].includes("-city") &&
          !params.slugs[2].includes("-state")
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) === params.slugs[2]
                )?.filterId,
                countryId: listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[1]
                        )?.countryId
                      ),
                    ]
                  : null,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: listDataFilter?.find(
                (i) => slugify(i.filterName?.toLowerCase()) === params.slugs[3]
              )?.filterId,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
              countryId: listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )
                ? [
                    JSON.stringify(
                      listDataCountry?.find(
                        (i) =>
                          slugify(i.countryName?.toLowerCase()) ===
                          params.slugs[1]
                      )?.countryId
                    ),
                  ]
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        if (params.slugs[0] === "world") {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              isWorld: true,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });
          const newListDataFilter = [];
          for (const filterData of uniqBy(listDataFilter, "filterId")?.sort(
            (a, b) => a?.filterOrder - b?.filterOrder
          )) {
            const { listDataResult, countListDataResult } = await new Promise(
              (resolve, reject) => {
                paramsFinal = {
                  categoryType,
                  pageIndex: 0,
                  pageSize: 100,
                  sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                  progFilterId: filterData?.filterId,
                };
                VenueDao.find(paramsFinal)
                  .then((result) =>
                    resolve({
                      listDataResult: result.data,
                      countListDataResult: result.totalCount,
                    })
                  )
                  .catch((err) => reject(err));
              }
            );
            if (countListDataResult > 0) {
              newListDataFilter.push(filterData);
            }
          }

          listData = newListDataFilter;
        } else {
          listDataCountry = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic(
              continentDataSelected?.isCustomRegion
                ? {
                    categoryType,
                    progFilterType: "country",
                    region: continentDataSelected
                      ? JSON.stringify(continentDataSelected?.originalRegions)
                      : null,
                    // subregion: continentDataSelected
                    //   ? JSON.stringify(
                    //       continentDataSelected?.originalSubregions
                    //     )
                    //   : null,
                  }
                : {
                    categoryType,
                    progFilterType: "country",
                    region: continentDataSelected
                      ? JSON.stringify([continentDataSelected?.region])
                      : null,
                  }
            )
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataCountry;
        }
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        if (
          !params.slugs[1].includes("-city") &&
          !params.slugs[1].includes("-state") &&
          params.slugs[0] === "world"
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) === params.slugs[1]
                )?.filterId,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataState = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "state",
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listDataCity = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "city",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        if (
          !params.slugs[2].includes("-city") &&
          !params.slugs[2].includes("-state")
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                progFilterId: listDataFilter?.find(
                  (i) =>
                    slugify(i.filterName?.toLowerCase()) === params.slugs[2]
                )?.filterId,
                countryId: listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[1]
                        )?.countryId
                      ),
                    ]
                  : null,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: listDataFilter?.find(
                (i) => slugify(i.filterName?.toLowerCase()) === params.slugs[3]
              )?.filterId,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
              countryId: listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )
                ? [
                    JSON.stringify(
                      listDataCountry?.find(
                        (i) =>
                          slugify(i.countryName?.toLowerCase()) ===
                          params.slugs[1]
                      )?.countryId
                    ),
                  ]
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    } else if (process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub") {
      if (params.slugs.length >= 1) {
        // /guides/asia
        continentDataSelected = listDataContinent.find(
          (i) => slugify(i.region?.toLowerCase()) === params.slugs[0]
        );

        listDataCountry = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic(
            continentDataSelected?.isCustomRegion
              ? {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify(continentDataSelected?.originalRegions)
                    : null,
                  // subregion: continentDataSelected
                  //   ? JSON.stringify(continentDataSelected?.originalSubregions)
                  //   : null,
                }
              : {
                  categoryType,
                  progFilterType: "country",
                  region: continentDataSelected
                    ? JSON.stringify([continentDataSelected?.region])
                    : null,
                }
          )
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataCountry;
      }
      if (params.slugs.length >= 2) {
        // /guides/asia/indonesia
        listDataState = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "state",
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listDataCity = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "city",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listDataFilter = await new Promise((resolve, reject) => {
          LocationDao.findProgmatic({
            categoryType,
            progFilterType: "filter",
            region: JSON.stringify([
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.region,
            ]),
            // subregion: JSON.stringify([
            //   listDataCountry?.find(
            //     (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
            //   )?.subregion,
            // ]),
            countryId:
              listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )?.countryId || null,
          })
            .then((result) => resolve(result || []))
            .catch((err) => reject(err));
        });

        listData = listDataFilter;
      }
      if (params.slugs.length >= 3) {
        // /guides/asia/indonesia/bali
        if (
          !params.slugs[2].includes("-city") &&
          !params.slugs[2].includes("-state")
        ) {
          const { listDataResult, countListDataResult } = await new Promise(
            (resolve, reject) => {
              paramsFinal = {
                categoryType,
                pageIndex: 0,
                pageSize: 100,
                sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                countryId: listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )
                  ? [
                      JSON.stringify(
                        listDataCountry?.find(
                          (i) =>
                            slugify(i.countryName?.toLowerCase()) ===
                            params.slugs[1]
                        )?.countryId
                      ),
                    ]
                  : null,
              };
              VenueDao.find(paramsFinal)
                .then((result) =>
                  resolve({
                    listDataResult: result.data,
                    countListDataResult: result.totalCount,
                  })
                )
                .catch((err) => reject(err));
            }
          );

          listData = listDataResult;
          countListData = countListDataResult;
        } else {
          listDataFilter = await new Promise((resolve, reject) => {
            LocationDao.findProgmatic({
              categoryType,
              progFilterType: "filter",
              region: JSON.stringify([
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.region,
              ]),
              // subregion: JSON.stringify([
              //   listDataCountry?.find(
              //     (i) =>
              //       slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              //   )?.subregion,
              // ]),
              countryId:
                listDataCountry?.find(
                  (i) =>
                    slugify(i.countryName?.toLowerCase()) === params.slugs[1]
                )?.countryId || null,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
            })
              .then((result) => resolve(result || []))
              .catch((err) => reject(err));
          });

          listData = listDataFilter;
        }
      }
      if (params.slugs.length >= 4) {
        const { listDataResult, countListDataResult } = await new Promise(
          (resolve, reject) => {
            paramsFinal = {
              categoryType,
              pageIndex: 0,
              pageSize: 100,
              sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
              progFilterId: listDataFilter?.find(
                (i) => slugify(i.filterName?.toLowerCase()) === params.slugs[3]
              )?.filterId,
              stateId: params.slugs[2]?.includes("-state")
                ? listDataState?.find(
                    (i) =>
                      slugify(i.stateName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-state", "")
                  )?.stateId || null
                : null,
              cityId: params.slugs[2]?.includes("-city")
                ? listDataCity?.find(
                    (i) =>
                      slugify(i.cityName?.toLowerCase()) ===
                      params.slugs[2]?.replace("-city", "")
                  )?.cityId || null
                : null,
              countryId: listDataCountry?.find(
                (i) => slugify(i.countryName?.toLowerCase()) === params.slugs[1]
              )
                ? [
                    JSON.stringify(
                      listDataCountry?.find(
                        (i) =>
                          slugify(i.countryName?.toLowerCase()) ===
                          params.slugs[1]
                      )?.countryId
                    ),
                  ]
                : null,
            };
            VenueDao.find(paramsFinal)
              .then((result) =>
                resolve({
                  listDataResult: result.data,
                  countListDataResult: result.totalCount,
                })
              )
              .catch((err) => reject(err));
          }
        );

        listData = listDataResult;
        countListData = countListDataResult;
      }
    }

    if (listData <= 0) {
      // return {
      //   notFound: true,
      // };
    }

    return {
      props: {
        categoryType,
        listDataCountry: listDataCountry?.filter((item) => item.countryName),
        listDataState: listDataState?.filter((item) => item.stateName),
        listDataCity: listDataCity?.filter((item) => item.cityName),
        listDataFilter: listDataFilter?.filter((item) => item.filterName),
        listData,
        countListData,
        slugs: params.slugs,
        paramsFinal,
      },
    };
  } catch (err) {
    console.error("err", err);
    return {
      notFound: true,
    };
  }
}

const GuideSlug = (props) => {
  if (process.env.NEXT_PUBLIC_APP_NAME === "Vybeful") {
    return <GuideVybeful {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "RooftopClub") {
    return <GuideRooftop {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "Cocktayl") {
    return <GuideCocktayl {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "Beachful") {
    return <GuideBeachful {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "SpaClub") {
    return <GuideSpa {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "Festicket") {
    return <GuideFestyful {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "PrefabWorld") {
    return <GuidePrefab {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "Zoopedia") {
    return <GuideZoo {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "Parkful") {
    return <GuideParkful {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "WorldCasino") {
    return <GuideCasino {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "Castlepedia") {
    return <GuideCastle {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "LuxResort Club") {
    return <GuideResort {...props} />;
  } else if (process.env.NEXT_PUBLIC_APP_NAME === "AparthotelClub") {
    return <GuideAparthotel {...props} />;
  } else {
    return null;
  }
};

export default GuideSlug;
